/* Live zoeksuggesties in de desktopheader.

   Gebruikt Shopify's eigen suggestie-API (/search/suggest.json). Er gaat pas
   een aanvraag uit als iemand even stopt met typen, en een nieuwe aanvraag
   annuleert de vorige — zo blijft het rustig terwijl je typt. */
/* Rij 1 klapt weg zodra de header vastplakt.

   We hangen daarvoor een onzichtbaar peilertje van 1px vlak boven de header.
   Zodra dat uit beeld schuift, staat de header vast en krimpt rij 1. Een
   IntersectionObserver is hier betrouwbaarder dan meeluisteren met scrollen:
   die vuurt ook als de pagina op een andere manier verspringt. */
(function () {
  var dh = document.querySelector('[data-lf-dh]');
  if (!dh || !('IntersectionObserver' in window)) return;

  var wikkel = dh.parentElement;
  if (!wikkel.parentNode) return;

  /* Het peilertje komt vlak vóór de sectie te staan, in de gewone stroom.
     De negatieve ondermarge heft die ene pixel weer op, zodat de pagina niet
     verschuift. Aan de sectiewikkel zelf raken we niets: daar staat de
     sticky-positie op, en een inline stijl zou die overschrijven. */
  var peiler = document.createElement('div');
  peiler.setAttribute('aria-hidden', 'true');
  peiler.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;';
  wikkel.parentNode.insertBefore(peiler, wikkel);

  function zet(gekrompen) {
    dh.classList.toggle('is-gekrompen', gekrompen);
  }

  new IntersectionObserver(function (entries) {
    zet(!entries[0].isIntersecting);
  }, { threshold: 0 }).observe(peiler);

  /* Tweede weg naar hetzelfde resultaat. De observer is de normale aansturing,
     maar als die niet aanslaat blijft rij 1 anders open staan.

     Bewust zonder animatieframe: browsers bevriezen die zodra een tabblad niet
     zichtbaar is, en dan zou juist deze reserveweg óók stilvallen. Een simpele
     tijdrem doet hier hetzelfde werk en blijft altijd draaien. */
  var laatst = 0;
  window.addEventListener('scroll', function () {
    var nu = Date.now();
    if (nu - laatst < 80) return;
    laatst = nu;
    zet((window.scrollY || window.pageYOffset) > 1);
  }, { passive: true });
})();

(function () {
  var form = document.querySelector('[data-lf-dh-zoekform]');
  if (!form) return;

  var invoer = form.querySelector('[data-lf-dh-zoek]');
  var paneel = form.querySelector('[data-lf-dh-suggesties]');
  if (!invoer || !paneel) return;

  var WACHT = 220;   // ms nadat het typen stopt
  var MINIMUM = 2;   // vanaf hoeveel tekens we zoeken
  var timer = null;
  var controle = null;
  var actief = -1;

  /* Bedragen komen uit het thema zelf, niet uit een vast valutateken. Het
     formaat staat in theme.settings.moneyFormat en wordt in layout/theme.liquid
     door Liquid neergezet, zodat dit hetzelfde toont als de productpagina en
     blijft kloppen als de valuta of Markets verandert.

     Zonder theme.js valt hij terug op het kale bedrag: geen bedrag is beter
     dan een bedrag met het verkeerde teken ervoor. */
  function geld(bedrag) {
    var n = parseFloat(bedrag);
    if (isNaN(n)) return '';
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
      return theme.Currency.formatMoney(Math.round(n * 100), theme.settings.moneyFormat);
    }
    return n.toFixed(2);
  }

  function veilig(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function sluit() {
    paneel.hidden = true;
    paneel.innerHTML = '';
    actief = -1;
  }

  /* De lege staat: populaire zoekopdrachten en bestsellers. Die staat één keer
     in het thema, als <template> in snippets/lodyfair-zoek.liquid, en wordt door
     het mobiele paneel al gebruikt. Hier lenen we hem, zodat een bezoeker die
     niets vindt op desktop dezelfde uitweg krijgt als op mobiel in plaats van
     een doodlopende zin.

     Staat de zoekoverlay uit, dan bestaat de template niet en blijft het bij de
     melding alleen — precies zoals het hiervoor was. */
  function legeStaat() {
    var sjabloon = document.querySelector('[data-lf-zk-leeg]');
    return sjabloon ? sjabloon.content.cloneNode(true) : null;
  }

  /* Dezelfde zin als op mobiel, uit hetzelfde vertaalbestand.

     Let op: dat attribuut bevat al kant-en-klare HTML — de aanhalingstekens
     staan er als &quot; in. Alleen de zoekterm van de bezoeker wordt hier nog
     onschadelijk gemaakt; de zin zelf niet, anders zie je &quot; letterlijk in
     beeld staan. Het mobiele paneel doet het op precies dezelfde manier. */
  function nietsTekst(zoekterm) {
    var overlay = document.querySelector('[data-lf-zk]');
    var sjabloon = (overlay && overlay.getAttribute('data-tekst-niets')) ||
      'Nothing found for &quot;__TERM__&quot;.';
    return sjabloon.replace('__TERM__', veilig(zoekterm));
  }

  function teken(producten, zoekterm) {
    if (!producten.length) {
      paneel.innerHTML = '<span class="lf-dh__sug-leeg">' +
        nietsTekst(zoekterm) + '</span>';
      var uitweg = legeStaat();
      if (uitweg) paneel.appendChild(uitweg);
      paneel.hidden = false;
      actief = -1;
      return;
    }

    var html = '';
    producten.forEach(function (p) {
      var foto = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      var prijs = geld(p.price);
      var oud = '';
      if (p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price)) {
        oud = '<span class="lf-dh__sug-oud">' + geld(p.compare_at_price) + '</span>';
      }
      html += '<a class="lf-dh__sug" href="' + veilig(p.url) + '">' +
        (foto ? '<img src="' + veilig(foto) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<span class="lf-dh__sug-titel">' + veilig(p.title) + '</span>' +
        '<span class="lf-dh__sug-prijs">' + prijs + oud + '</span>' +
        '</a>';
    });

    html += '<a class="lf-dh__sug-alles" href="' + form.getAttribute('action') +
      '?q=' + encodeURIComponent(zoekterm) + '&type=product">All results for "' + veilig(zoekterm) + '"</a>';

    paneel.innerHTML = html;
    paneel.hidden = false;
    actief = -1;
  }

  function zoek(term) {
    if (controle) controle.abort();
    controle = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controle.signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.resources || !d.resources.results) return;
        teken(d.resources.results.products || [], term);
      })
      .catch(function () { /* afgebroken of netwerkfout: paneel gewoon laten staan */ });
  }

  invoer.addEventListener('input', function () {
    var term = invoer.value.trim();
    if (timer) clearTimeout(timer);
    if (term.length < MINIMUM) { sluit(); return; }
    timer = setTimeout(function () { zoek(term); }, WACHT);
  });

  invoer.addEventListener('focus', function () {
    var term = invoer.value.trim();
    if (term.length >= MINIMUM && paneel.innerHTML) paneel.hidden = false;
  });

  /* toetsenbord: pijltjes door de suggesties, Enter volgt de gemarkeerde */
  invoer.addEventListener('keydown', function (e) {
    var items = paneel.querySelectorAll('.lf-dh__sug');
    if (e.key === 'Escape') { sluit(); return; }
    if (!items.length || paneel.hidden) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      actief += (e.key === 'ArrowDown' ? 1 : -1);
      if (actief < 0) actief = items.length - 1;
      if (actief >= items.length) actief = 0;
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-actief', i === actief);
      items[actief].scrollIntoView({ block: 'nearest' });
      return;
    }

    if (e.key === 'Enter' && actief >= 0 && items[actief]) {
      e.preventDefault();
      window.location.href = items[actief].getAttribute('href');
    }
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) sluit();
  });
})();
